var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearSafetyHelmet50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.849,18.038C35.07,12.711,31.078,8,23.5,8C15,8,11,13.925,11,20v1h30v-1L35.849,18.038z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.675,25.994L35,22.874V22c0-6.617-5.159-12-11.5-12S12,15.383,12,22 c0,5.021,1.491,7.787,2.688,10.01C15.421,33.369,16,34.443,16,35.676V39h2v-3.324c0-1.737-0.753-3.135-1.551-4.615 C15.301,28.931,14,26.516,14,22c0-5.514,4.262-10,9.5-10S33,16.486,33,22v1.376l1.997,3.719C34.792,27.181,33,27.928,33,27.928 v4.381C33,33.793,31.771,35,30.262,35H27v4h2v-2h1.262C32.875,37,35,34.896,35,32.309v-3.048c0.397-0.166,0.842-0.352,0.852-0.356 c0.471-0.223,0.833-0.616,1.018-1.109C37.095,27.196,37.021,26.528,36.675,25.994z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearSafetyHelmet50);
export default __webpack_public_path__ + "static/media/icons8-wear-safety-helmet-50.6d176817ce238575553cfea0d21cb61a.svg";
export { ForwardRef as ReactComponent };